const TRACK_PATH = '/api/track';
const VISIT_KEY = 'ftlo.visit';

function visit(): string {
  let id = sessionStorage.getItem(VISIT_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(VISIT_KEY, id);
  }
  return id;
}

function arrival() {
  const params = new URLSearchParams(window.location.search);
  const referrer = document.referrer ? new URL(document.referrer) : null;
  return {
    referrer:
      referrer && referrer.origin !== window.location.origin
        ? referrer.host
        : null,
    utmSource: params.get('utm_source'),
    utmCampaign: params.get('utm_campaign'),
  };
}

const arrivedFrom = arrival();

function send(event: {
  kind: 'view' | 'click';
  path: string;
  target?: string;
}) {
  void fetch(TRACK_PATH, {
    method: 'POST',
    body: JSON.stringify({
      ...event,
      ...arrivedFrom,
      visit: visit(),
      viewportWidth: window.innerWidth,
      build: import.meta.env.VITE_BUILD_ID ?? null,
    }),
    keepalive: true,
  }).catch(() => undefined);
}

export function trackView(path: string): void {
  send({ kind: 'view', path });
}

// Actions only. Inputs, options, radios, and checkboxes hold form answers.
const CLICKABLE =
  '[data-track], button, a[href], summary, [role="button"], [role="tab"], [role="menuitem"]';

function nameOf(element: Element): string {
  const labelledBy = element.getAttribute('aria-labelledby');
  const name =
    element.getAttribute('data-track') ??
    element.getAttribute('aria-label') ??
    (labelledBy ? document.getElementById(labelledBy)?.textContent : null) ??
    element.textContent;
  return name.replace(/\s+/g, ' ').trim();
}

function targetOf(element: Element): string {
  const name = nameOf(element);
  if (name) return name;
  if (!(element instanceof HTMLAnchorElement))
    return element.tagName.toLowerCase();
  const url = new URL(element.href);
  return url.origin === window.location.origin
    ? url.pathname
    : url.host + url.pathname;
}

export function watchClicks(): void {
  document.addEventListener(
    'click',
    (event) => {
      const element =
        event.target instanceof Element
          ? event.target.closest(CLICKABLE)
          : null;
      if (!element) return;
      send({
        kind: 'click',
        path: window.location.pathname,
        target: targetOf(element).slice(0, 100),
      });
    },
    { capture: true },
  );
}
